import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class HtmlSanitizerService {

    constructor(private sanitizer: DomSanitizer) { }

    sanitizeHtml(content: string): SafeHtml {
        if (!content) {
            return '';
        }
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }

    sanitizeHtmlArray(contentArray: string[]): SafeHtml[] {
        if (!contentArray || !contentArray.length) {
            return [];
        }
        return contentArray.map(content => this.sanitizeHtml(content));
    }

    sanitizeAppContent(data: any): {
        safeSubCategoryContent: SafeHtml,
        safeGuidanceContent: SafeHtml,
        safeRelatedPoliciesContent: SafeHtml,
        safeQaContents: SafeHtml[]
    } {
        const result = {
            safeSubCategoryContent: null as unknown as SafeHtml,
            safeGuidanceContent: null as unknown as SafeHtml,
            safeRelatedPoliciesContent: null as unknown as SafeHtml,
            safeQaContents: [] as SafeHtml[]
        };

        if (!data) {
            return result;
        }

        if (data.subCategoryContent?.content) {
            result.safeSubCategoryContent = this.sanitizeHtml(data.subCategoryContent.content);
        }

        if (data.guidance?.content) {
            result.safeGuidanceContent = this.sanitizeHtml(data.guidance.content);
        }

        if (data.relatedPolicies?.content) {
            result.safeRelatedPoliciesContent = this.sanitizeHtml(data.relatedPolicies.content);
        }

        if (data.qa && data.qa.length > 0) {
            result.safeQaContents = this.sanitizeHtmlArray(
                data.qa.map((item: any) => item.content)
            );
        }

        return result;
    }
}